'use client'

import { useEffect, useState } from 'react'

import MicrosoftCatalogClient from '@/app/[lang]/(main)/marketplace/microsoft/MicrosoftCatalogClient'
import { logger } from '@/utils/logger'
import type { CatalogItem, PricingSegment } from '@/types/marketplace'

export const CATALOG_INDEX_PATH = '/marketplace/catalog-index'

interface CatalogIndexLoaderProps {
  initialProducts: CatalogItem[]
  initialCategory?: string
  initialSegment?: PricingSegment | 'all'
}

/** Renders the catalog from the first view's rows, then swaps in the full index for tabs and search */
export default function CatalogIndexLoader({
  initialProducts,
  initialCategory,
  initialSegment,
}: CatalogIndexLoaderProps) {
  const [products, setProducts] = useState(initialProducts)

  useEffect(() => {
    const controller = new AbortController()
    fetch(CATALOG_INDEX_PATH, { signal: controller.signal })
      .then((response) => {
        if (!response.ok) throw new Error(`HTTP ${response.status}`)
        return response.json() as Promise<CatalogItem[]>
      })
      .then(setProducts)
      .catch((error: unknown) => {
        if (controller.signal.aborted) return
        // The first view's rows still render; only other tabs and search stay partial
        logger.warn('Catalog index did not load', { message: error instanceof Error ? error.message : String(error) })
      })
    return () => controller.abort()
  }, [])

  return (
    <MicrosoftCatalogClient products={products} initialCategory={initialCategory} initialSegment={initialSegment} />
  )
}
